import { BlobRecord } from '@/@rails/activestorage/src/blob_record.js';
import { BlobUpload } from '@/@rails/activestorage/src/blob_upload.js';
import { AzureBlobUpload } from "./azure_blob_upload";
import { FileChecksum } from './file_checksum';

// https://github.com/rails/rails/blob/main/activestorage/app/javascript/activestorage/direct_upload.js
ActiveStorage.DirectUpload.prototype.create = function (callback) {
  const fc = new FileChecksum(this.file);
  notify(this.delegate, "directUploadWillCreateChecksum", fc)

  fc.create((error, checksum) => {
    if (error) {
      callback(error)
      return
    }

    const blob = new BlobRecord(this.file, checksum, this.url, this.customHeaders)
    notify(this.delegate, "directUploadWillCreateBlobWithXHR", blob.xhr)

    blob.create(error => {
      if (error) {
        callback(error)
      } else {
        let upload;
        if (blob.attributes.service_name === 'azure') {
          upload = new AzureBlobUpload(blob)
          notify(this.delegate, "directUploadWillStoreFileWithAzure", upload)
        }
        else {
          upload = new BlobUpload(blob)
          notify(this.delegate, "directUploadWillStoreFileWithXHR", upload.xhr)
        }
        upload.create(error => {
          if (error) {
            callback(error)
          } else {
            callback(null, blob.toJSON())
          }
        })
      }
    })
  })
}

function notify(object, methodName, ...messages) {
  if (object && typeof object[methodName] == "function") {
    return object[methodName](...messages)
  }
}
